"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _Report = _interopRequireDefault(require("../model/Report"));

var _ReportStatus = _interopRequireDefault(require("../model/ReportStatus"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
* Report service.
* @module api/ReportApi
* @version 1.0.0
*/
var ReportApi = /*#__PURE__*/function () {
  /**
  * Constructs a new ReportApi. 
  * @alias module:api/ReportApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function ReportApi(apiClient) {
    _classCallCheck(this, ReportApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Callback function to receive the result of the getReport operation.
   * @callback module:api/ReportApi~getReportCallback
   * @param {String} error Error message, if any.
   * @param {module:model/ReportStatus} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * 获取报活状态
   * 获取报活状态, 报活次数不会落盘, 每次进程重启即归零
   * @param {module:api/ReportApi~getReportCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/ReportStatus}
   */


  _createClass(ReportApi, [{
    key: "getReport",
    value: function getReport(callback) {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ReportStatus["default"];
      return this.apiClient.callApi('/report', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the postReport operation.
     * @callback module:api/ReportApi~postReportCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * app 报活和提交 app 实例运行信息
     * app 报活和提交 app 实例运行信息
     * @param {Object} opts Optional parameters
     * @param {module:model/Report} opts.data 
     * @param {module:api/ReportApi~postReportCallback} callback The callback function, accepting three arguments: error, data, response
     */

  }, {
    key: "postReport",
    value: function postReport(opts, callback) {
      opts = opts || {};
      var postBody = opts['data'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/report', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
  }]);

  return ReportApi;
}();

exports["default"] = ReportApi;